import { render, staticRenderFns } from "./DataCategory2.vue?vue&type=template&id=ab0bc994"
import script from "./DataCategory2.vue?vue&type=script&lang=js"
export * from "./DataCategory2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports